import { useOutletContext } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { TableControl, useTableControl } from "@/components/table-control";
import { useGetSessionRoomSystems } from "@/features/room-systems/api/get-room-systems";
import { RoomSystemsTable } from "@/features/room-systems/components/room-systems-table";

export function SessionRoomSystems() {
  const { pagination, setPagination } = useTableControl();
  const outletContext = useOutletContext<{
    tableControl?: TableControl;
  }>();

  const {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
    isPlaceholderData,
    isFetching,
  } = useGetSessionRoomSystems({
    pageSize: pagination.pageSize,
    pageIndex: pagination.pageIndex,
    search: outletContext?.tableControl?.search ?? undefined,
  });

  if (isLoading)
    return (
      <section>
        <LoadingScreen />
      </section>
    );

  if (isError || !isSuccess) {
    return <ErrorMessage error={error} />;
  }

  return (
    <section>
      {isSuccess && (
        <RoomSystemsTable
          data={data.items}
          pagination={pagination}
          onPaginationChange={setPagination}
          pageCount={Math.ceil(data.count / pagination.pageSize)}
          isLoading={isFetching && isPlaceholderData}
        />
      )}
    </section>
  );
}
